import { createGlobalStyle } from 'styled-components';

export const THEME = {
  actionsPanelHeight: '50px',
  colors: {
    white: '#ffffff',
    black: '#000000',
    dark: '#006F93',
    darker: '#00516B',
    blue: '#0076C0',
    gray: '#8795A1',
    green: '#2E8540',
    orange: '#B95E06',
    red: '#CF4845',
    primary: {
      accent: '#2dadf7',
      dark: '#325bcf',
      darker: '#293845',
      light: '#6294ff',
      main: '#4d77f0',
    },
    secondary: {
      main: '#ff8c10',
    },
    grayLight: '#DFE7ED',
  },
  headerHeight: '48px',
  input: {
    backgroundColor: '#ffffff',
    borderColor: '#d8d8d8',
    placeholderColor: '#939393',
  },
  table: {
    body: {
      backgroundColor: '#ffffff',
      fontSize: 12,
      height: 31,
      textColor: '#000',
      treeRowBackgroundColor: '#f8f8f8',
    },
    borderColor: '#d8d8d8',
    header: {
      backgroundColor: '#ffffff',
      fontSize: '0.875rem',
      height: 50,
      sortBorder: '#000',
      textColor: '#484848',
    },
  },
};

export const GlobalStyle = createGlobalStyle`
  html {
    font-size: 16px;
  }

  body {
    background-color: ${THEME.colors.white};
    font-size: 0.875rem;
    font-family: "Roboto", sans-serif;
  }
`;
